"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const usePhoneInputStyles = ({ error, forceLtr }) => {
    const theme = (0, material_1.useTheme)();
    const reactTelInputStyles = {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: error
            ? `solid 1px ${theme.qlub.palette.danger.main}`
            : `solid 1px ${theme.qlub.palette.onSurfaceColors.mediumEmphasis}`,
        '&:focus-within': {
            border: error ? `solid 1px ${theme.qlub.palette.danger.main}` : `solid 1px ${theme.palette.primary.main}`,
        },
        borderRadius: '8px',
        '&:disabled': {
            cursor: 'not-allowed',
        },
    };
    const formControlStyles = Object.assign(Object.assign({ position: 'relative', fontSize: '14px', letterSpacing: '0.01rem', marginTop: '0 !important', marginBottom: '0 !important', paddingLeft: '64px', marginLeft: 0, background: '#ffffff', border: 'none', borderRadius: '8px', lineHeight: '25px', height: '48px', width: '100%', outline: 'none', direction: 'ltr' }, (!forceLtr
        ? {
            "html[dir='rtl'] &": {
                paddingRight: '64px',
                direction: 'ltr',
                textAlign: 'left',
            },
        }
        : {})), { '&::placeholder': {
            color: '#9b9eab',
        }, '&.invalid-number': {
            border: '2px solid #df1d17',
            '&:focus': {
                border: '2px solid #df1d17',
            },
        }, '& input[disabled]': {
            '& + .flag-dropdown:hover': {
                cursor: 'default',
            },
        } });
    const flagDropdownStyles = {
        position: 'absolute',
        top: 0,
        bottom: 0,
        padding: 0,
        left: 0,
        backgroundColor: ' #f5f5f5',
        border: 'none',
        borderRadius: ' 8px 0 0 8px',
        borderRight: 'none',
        '&:hover': {
            cursor: 'pointer',
        },
        '&:focus': {
            cursor: 'pointer',
        },
        '&.invalid-number': {
            border: '2px solid #df1d17',
            borderRight: 'none',
        },
        '&.open': {
            zIndex: 2,
            background: '#fff',
            borderRadius: '8px 0 0 0',
        },
    };
    return {
        reactTelInputStyles,
        formControlStyles,
        flagDropdownStyles,
    };
};
exports.default = usePhoneInputStyles;
